export const calculateProfileCompletion = (values) => {
    // 1. Personal Details
    const personalFields = ['firstName', 'lastName', 'phone', 'email', 'jobTitle'];
    const hasAllPersonalFields = personalFields.every(
        field => values[field] !== null && values[field] !== undefined && values[field] !== ''
    );
    const hasContactMethod = values.whatsApp || values.slack;
    const personalDetailsComplete = hasAllPersonalFields && !!hasContactMethod;

    // 2. Company Details
    const companyFields = ['companyName', 'companyWebsite'];
    const addressFields = ['addressLine1', 'city', 'state', 'country', 'zipCode'];
    const companyDetailsComplete =
        companyFields.every(field => values[field]) &&
        values.address &&
        addressFields.every(field => values.address[field]);

    // 3. Working Hours
    const workingHoursComplete =
        values.workingHours &&
        values.workingHours.timeZone &&
        values.workingHours.start !== null &&
        values.workingHours.start !== undefined &&
        values.workingHours.end !== null &&
        values.workingHours.end !== undefined;

    // 4. Billing Address
    // Filter out null/undefined values and check if there's at least one valid email
    const validBillingEmails = Array.isArray(values.billingEmailAddress)
        ? values.billingEmailAddress.filter(email => email != null && email !== '')
        : [];
    const billingDetailsComplete = validBillingEmails.length > 0;

    // 5. Payment Gateway
    // const paymentGatewayComplete = !!values.paymentMethodAvailable;

    // Compute percentage (each section = 25%)
    const completedSections = [
        personalDetailsComplete,
        companyDetailsComplete,
        workingHoursComplete,
        billingDetailsComplete,
        // paymentGatewayComplete
    ].filter(Boolean).length;

    let totalPercentageProfileCompleted = completedSections * 25;
    totalPercentageProfileCompleted = Number(totalPercentageProfileCompleted.toFixed(0));

    return {
        personalDetailsComplete,
        companyDetailsComplete,
        workingHoursComplete,
        billingDetailsComplete,
        // paymentGatewayComplete,
        totalPercentageProfileCompleted
    };
};
